import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

const pluginsPath = [];

const files = require.context('./modules', true, /\.js$/);
const modules = {};

files.keys().forEach(key => {
  let n = key.replace(/\.\/([a-z, A-Z]+)\.js$/, function(match, group) {
    return group.replace(/([A-Z])/g, '_$1').toUpperCase();
  });
  modules[n] = files(key).default;
  if (files(key).field) {
    pluginsPath.push(...files(key).field.map(el => `${n}.${el}`));
  }
});

const plugins = [
  createPersistedState({
    storage: window.sessionStorage,
    paths: pluginsPath,
  }),
];

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  plugins,
});
